function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    // 生成随机时间
    function generateRandomTime() {
      var hours = Math.floor(Math.random() * 15) + 1
      var minutes = Math.floor(Math.random() * 60)
      var seconds = Math.floor(Math.random() * 60)
      //总共的毫秒数
      var targetTime = (hours * 3600 + minutes * 60 + seconds) * 1000

      return targetTime
    }
    function TimeDown(value) {
      //倒计时的总秒数
      var totalSeconds = parseInt(value / 1000)
      //取模（余数）
      var modulo = totalSeconds % (60 * 60 * 24)
      //小时数
      var hours = Math.floor(modulo / (60 * 60))
      modulo = modulo % (60 * 60)
      //分钟
      var minutes = Math.floor(modulo / 60)
      //秒
      var seconds = modulo % 60

      hours = hours.toString().length == 1 ? '0' + hours : hours
      minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
      seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

      //输出到页面
      $('.sp_hour').html(hours)
      $('.sp_minute').html(minutes)
      $('.sp_second').html(seconds)
      //延迟一秒执行自己
      if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
      } else {
        setTimeout(function () {
          TimeDown(value - 1000)
        }, 1000)
      }
    }
    TimeDown(generateRandomTime())
    // 轮播
    $('#goods-image_header_1').show()
    $('#goods-image_header_2').hide()
    let header_flag = false
    setInterval(() => {
      header_flag = !header_flag
      if (header_flag) {
        $('#goods-image_header_1').hide()
        $('#goods-image_header_2').show()
      } else {
        $('#goods-image_header_1').show()
        $('#goods-image_header_2').hide()
      }
    }, 1000)
    $('.sp-sizes').click(function () {
      $('.sp-alert').show()
    })
    $('.sp-alert').click(function () {
      $('.sp-alert').hide()
    })
    //
    var swiper = new Swiper('.mySwiper', {
      direction: 'vertical',
      spaceBetween: 20,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    })
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0789/9604/6140/files/20240901-pro-0.png',
      'https://cdn.shopify.com/s/files/1/0789/9604/6140/files/20240901-pro-1.png',
      'https://cdn.shopify.com/s/files/1/0789/9604/6140/files/20240901-pro-2.png',
      'https://cdn.shopify.com/s/files/1/0789/9604/6140/files/20240901-pro-3.png',
      'https://cdn.shopify.com/s/files/1/0789/9604/6140/files/20240901-pro-4.png',
      'https://cdn.shopify.com/s/files/1/0789/9604/6140/files/20240901-pro-5.png',
    ]
    var swiper2 = new Swiper('.mySwiper2', {
      thumbs: {
        swiper: swiper,
      },
    })
    swiper.el.onclick = function (e) {
      // 切换到点击的slide
      var clickIndex = e.target.parentNode.getAttribute('data-index')
      $('.sp-pro-img>img').attr('src', imgArr[clickIndex])
      //
      choseActive(clickIndex)
    }
      let prods = window.product
    console.log(prods,'prods')
    // 初始化
    alignmentFns.initialize()
    
function getCur(){
  let color = $('#color li.active').attr('data-val')
  let size = $('#size li.active').attr('data-val')
  console.log(color, prods.filter(item=> item.option1 == color && item.option2 == size)[0])
  return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
}
  function changePrice(){
          let num = $('#calcNumber').val()
          let price = (getCur().price * num / 100).toFixed(0)
          let compare = (getCur().compare_at_price * num / 100).toFixed(0)
          $('#new').html(price)
          $('#old').html(compare)
          // let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
          // $(".product-part .sp-brand p span").html(off_font );
        }

    
    //加减
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
        changePrice()
      }
      // var number = Number($('#calcNumber').val())
      // $('#new').html(number * Number(319))
      // $('#old').html(number * Number(638))
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      changePrice()
      // var number = Number($('#calcNumber').val())
      // $('#new').html(number * Number(319))
      // $('#old').html(number * Number(638))
    })
      $('.sp-buynow').click(function(){
          let num = $('#calcNumber').val()
          // window.location.href = '/cart/' + getCur().id + ':' + num
        })
        // 弹窗 start
   var main_id = "";
    $('.emitCheckout').click(function(){
      console.log('1111')
      main_id = getCur().id
      // main_id = $(this).siblings('.select_span').find('span.on').data('id')
      // window.location.href = "/cart/" + id + ":1"
    })

  function getPopProdId(){
    let selectVals = [];
   $('.overbuy_wrap .sp-subopt.active').each(function(){
      selectVals.push($(this).data('val'))
    })

    let cur = popProduct.filter(item => {
      let option1 = selectVals[0];
      let option2 = null;
      let option3 = null;
      if(selectVals[1]){
        option2 = selectVals[1];
      }
      if(selectVals[2]){
        option3 = selectVals[2];
      }

      
      return item.option1 == option1 && item.option2 == option2 && item.option3 == option3
    })

 
    
    return cur[0];
  }

  $('.overbuy-select div').click(function(){
     $(this).siblings().removeClass('active')
     $(this).addClass('active')
    let cur = getPopProdId();
    
    if(cur){
      $(".main-btn").text('Få 10% rabatt').removeClass("overbuy_disabled")
      let _price = parseFloat(cur.price / 100).toFixed(0);
      let _compare_at_price = parseFloat(cur.compare_at_price / 100).toFixed(0);
  
      $('.overbuy_price span').eq(0).html( _price + ' kr');
      $('.overbuy_price span').eq(1).html(_compare_at_price  + ' kr');
    }else{
      $(".main-btn").text("Unavailable").addClass("overbuy_disabled")
    }
    
  })

  


  window.emitSubmit = function(_type){
    let num = $('#calcNumber').val()
     if(_type == 'all'){
      // var bundle_sku = data[$('input[name="overbuy1"]:checked').val()][$('input[name="overbuy2"]:checked').val()]
      let _id = getPopProdId()?.id;
       if(!_id) return
      console.log(_id)
       
      window.location.href = `/cart/${main_id}:${num},${_id}:1`
    }else{
      window.location.href = `/cart/${main_id}:${num}`
    }
  }



  // 弹窗 end
    // 数量
    // $('#2').change(function () {
    //   var number = Number($('#2').val())
    //   $('#new').html('')
    //   $('#old').html('')
    //   $('#new').html((number * Number(499)).toFixed(0))
    //   $('#old').html((number * Number(1000)).toFixed(0))
    // })
    // 颜色选择
    $('.sp-size-wraper li').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      var index = $(this).index()
      changePrice()
      swiper2.slideTo(index)
      $('.sp-pro-img>img').attr('src', imgArr[index])
    })
    $('.sp-color-wraper li').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
    })
    function choseActive(clickIndex) {
      var index = clickIndex
      $('.sp-size-wraper li')
        .eq(index)
        .addClass('active')
        .siblings()
        .removeClass('active')
    }
    addCart()
      function addCart() {
    // 加入购物车
    $('#addCart').click(function () {
      // do something here
      // var number = Number($('.sp-buy-car span').html()) + Number($('#2').val())
      // $('.sp-buy-car span').html(number)
      // if (number == 0) {
      //   $('.sp-buy-car span').css('background', '#999')
      // } else {
      //   $('.sp-buy-car span').css('background', '#f24a00')
      // }
          var data = {
      id: getCur().id,
        quantity: $('#calcNumber').val(),
    };

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      success: function () {
        $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
          $('#cardNum').html(result.item_count)
            if (number == 0) {
        $('.sp-buy-car span').css('background', '#999')
      } else {
        $('.sp-buy-car span').css('background', '#f24a00')
      }
        });
      },
      dataType: "json",
    });
      var img = $('.sp-pro-img img')
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $('.sp-part5').append(flyer)
      $('.clone').css({
        width: '714px',
        height: '714px',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })
      var offset = $('.sp-buy-car')[0].getBoundingClientRect()
      $('.sp-buy-car').addClass('shake')
      setTimeout(() => {
        $('.sp-buy-car').removeClass('shake')
      }, 1000)
      let finish = $('.sp-buy-car')
      $('.clone').animate(
        {
          top: finish[0].offsetTop + 133,
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
  }
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    // var links = document.querySelectorAll('a[href^="#shopping"]')
    // links.forEach(function (link) {
    //   link.addEventListener('click', function (event) {
    //     event.preventDefault() // 阻止默认的跳转行为
    //     // var targetElement = document.getElementById('shopping');
    //     // if (targetElement) {
    //     //     targetElement.scrollIntoView({ behavior: 'smooth' });
    //     // } // 方式一
    //     const targetElement = document.getElementById('shopping') // 获取跳转目标节点
    //     const offsetTop =
    //       targetElement.offsetTop
    //     window.scroll({
    //       top: offsetTop * $('div#root').css('zoom'),
    //       behavior: 'smooth', // 使用 smooth 实现平滑滚动
    //     }) // 方式二
    //   })
    // })
    var links = document.querySelectorAll('a[href^="#shopping"]');
	  links.forEach(function (link) {
		link.addEventListener("click", function (event) {
            event.preventDefault();

            const target = document.getElementById("shopping");
            if (!target) return;

            const timeHeight =
            document.querySelector(".time-part")?.getBoundingClientRect().height || 0;

            const headerHeight =
            document.querySelector(".sp-header-top")?.getBoundingClientRect().height || 0;

            const targetTop =
            target.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
            top: targetTop - timeHeight - headerHeight,
            behavior: "smooth",
            });
		});
	  });
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
